import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
  GridToolbarColumnsButton,
  GridToolbarExportContainer,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Mauhopdongvantai from "components/Hopdongvantai/Mauphuluc/Mauhopdongvantai.js";
import HopdongVTHKexcel from "components/Xuatexcel/Hopdongvantai/HopdongVTHKexcel.js";
import dayjs from "dayjs";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const hdcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 70,
    headerAlign: "center",
  },
  {
    field: "tendonvi",
    headerName: "Đơn vị",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "sohopdong",
    headerName: "Số hợp đồng",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngayhopdong",
    headerName: "Ngày hợp đồng",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ten_dvthue",
    headerName: "Đơn vị thuê",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "diachi_dvthue",
    headerName: "Địa chỉ đơn vị thuê",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "mst_dvthue",
    headerName: "MST đơn vị thuê",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "diadiem_dau",
    headerName: "Điểm đầu",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "diadiem_cuoi",
    headerName: "Điểm cuối",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "hanhtrinh",
    headerName: "Hành trình",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "diemdontrakhach",
    headerName: "Điểm đón, trả khách",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "culy",
    headerName: "Cự ly (km)",
    width: 120,
    headerAlign: "center",
  },
  {
    field: "tg_donkhach",
    headerName: "Thời gian đón khách",
    width: 170,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("HH:mm DD/MM/YYYY"),
  },
  {
    field: "tg_trakhach",
    headerName: "Thời gian trả khách",
    width: 170,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("HH:mm DD/MM/YYYY"),
  },
  {
    field: "noidungkhac",
    headerName: "Nội dung khác",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "xacnhan",
    headerName: "Xác nhận",
    width: 130,
    headerAlign: "center",
  },
  {
    field: "ngaycn",
    headerName: "Ngày cập nhật",
    width: 150,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("HH:mm DD/MM/YYYY"),
  },
  {
    field: "nguoicn",
    headerName: "Người cập nhật",
    width: 150,
    headerAlign: "center",
  },
];

export default function Xacnhanhopdong() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(50);
  const [hopdong, setHopdong] = React.useState([]);
  const [idhopdong, setIdhopdong] = React.useState(0);
  const [disableBT, setDisableBT] = React.useState(true);
  const [openphuluc, setOpenphuluc] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  const handleClosephuluc = () => {
    setOpenphuluc(false);
    gethopdong();
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
        <GridToolbarColumnsButton />
        <GridToolbarExportContainer>
          <HopdongVTHKexcel />
        </GridToolbarExportContainer>
      </Box>
    );
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const gethopdong = () => {
    var url =
      Config.backend +
      "/api/phuongtien/gethopdongvtchuaxacnhan?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setHopdong(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xacnhan = () => {
    var url = Config.backend + "/api/Phuongtien/xacnhanhopdongvt";
    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: idhopdong,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          gethopdong();
          showNotification();
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  React.useEffect(() => {
    gethopdong();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12}>
        <FormControl style={{ width: "12%", marginTop: 5 }}>
          <Button
            color="success"
            variant="contained"
            style={{ height: 27 }}
            disabled={disableBT}
            onClick={xacnhan}
          >
            Xác nhận
          </Button>
        </FormControl>
        <FormControl style={{ width: "12%", marginLeft: 10, marginTop: 5 }}>
          <Button
            color="warning"
            variant="contained"
            style={{ height: 27 }}
            disabled={disableBT}
            onClick={() => setOpenphuluc(true)}
          >
            Phụ lục
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%", marginTop: 10 }}>
          <DataGrid
            getRowId={(row) => row.stt}
            rows={hopdong}
            columns={hdcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
            onRowClick={(params) => {
              setDisableBT(false);
              setIdhopdong(Number(params.row.id));
            }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openphuluc}
          onClose={handleClosephuluc}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Mẫu phụ lục
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosephuluc} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Mauhopdongvantai hopdong_id={idhopdong} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xác nhận thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
